/**
 * Reserved portal labels. Historical label names kept as-is ('Client',
 * 'À qualifier', 'OK', 'KO') — they are pure presentation labels backed by
 * dedicated issue columns (visibleToClient, needsQualification, validation).
 * Single source of truth — no magic label strings elsewhere.
 *  - Client    : makes an issue visible on the client portal (visibility flag)
 *  - ToQualify : "À qualifier" triage label
 *  - Ok / Ko   : client validation labels (toggled from the Kanban)
 */
export enum ReservedLabel {
  Client = 'Client',
  ToQualify = 'À qualifier',
  Ok = 'OK',
  Ko = 'KO',
}

/**
 * Validation-toggle subset: a ticket can be marked OK or KO (or cleared with
 * null). Used by the validation endpoint and the Kanban validation buttons.
 */
export type IssueValidationLabel = ReservedLabel.Ok | ReservedLabel.Ko;

/**
 * Labels managed exclusively by the portal (visibility, triage, validation).
 * They are never offered for selection nor settable through the generic
 * label fields of the issue create/update APIs — each has its own flow.
 */
export const RESERVED_LABELS: readonly string[] = Object.values(ReservedLabel);

export function isReservedLabel(name: string): boolean {
  return RESERVED_LABELS.includes(name);
}
